<template>
    <div class="attendance-container">
        <h2>Take Attendance</h2>

        <hr>
        <!-- <div class="group-select-container">
            <label for="group-select">Select Group:</label>
            <select v-model="selectedGroup" id="group-select" class="group-dropdown">
                <option value="">-- Select a Group --</option>
                <option v-for="group in groups" :key="group.id" :value="group.id">{{ group.name }}</option>
            </select>
        </div>
        <div class="counselor-select-container">
            <label for="counselor-select">Select Counselor:</label>
            <select v-model="selectedCounselor" id="counselor-select" class="counselor-dropdown">
                <option value="">-- Select a Counselor --</option>
                <option v-for="counselor in counselors" :key="counselor.id" :value="counselor.id">{{ counselor.user.name
                }}</option>
            </select>
        </div>

        <div class="time-slot-select-container">
            <label for="time-slot-select">Select Time Slot:</label>
            <select v-model="selectedTimeSlot" id="time-slot-select" class="time-slot-dropdown">
                <option value="">-- Select a Time Slot --</option>
                <option v-for="slot in timeSlots" :key="slot.id" :value="slot.id">{{ formatTime(slot.start_time) }} - {{
                    formatTime(slot.end_time) }}</option>
            </select>
        </div> -->
        <!-- <button @click="fetchStudents()" :disabled="!selectedGroup || !selectedCounselor || !selectedTimeSlot"
            class=" btn btn-load-attendance mb-2">Load Attendance</button> -->

        <button @click="$router.push('attendance/view')" class=" btn mb-2 ms-2">View Attendance</button>
        <!-- <p v-if="!selectedGroup" class="alert">Please select a group to view attendance.</p> -->

        <hr />
        <!-- <div class="search-container">
            <p class="text-start fw-bold">Search for student name to mark attendance</p>
            <input type="text" v-model="searchQuery" placeholder="Search students..." class="search-input"
                autocomplete="off" />
        </div> -->
        <transition name="fade" mode="out-in">
            <div class="table-container" v-if="filteredStudents.length">
                <table class="table table-bordered">
                    <thead class="sticky-header">
                        <tr>
                            <th>Name</th>
                            <th class="text-center" style="width: 200px;">
                                {{ getCurrentDayName() }}
                                <div class="date-label">{{ formatDateToUS(currentDate) }}</div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>

                        <tr v-for="student in filteredStudents" :key="student.student_id">
                            <td class="text-start">{{ student.user.name }}</td>
                            <td>
                                <template v-if="attendance[student.id] && attendance[student.id] === 'present'">
                                    <span v-if="attendance[student.id] === 'present'">✔</span>

                                </template>
                                <template v-else>
                                    <input type="button" class="btn btn-primary btn-sm " style="width: 200px;"
                                        @click="handleCheckboxChange($event, student, day)" value="Mark Attendance">
                                </template>
                            </td>
                        </tr>


                    </tbody>
                </table>
            </div>
        </transition>

        <p v-if="selectedGroup && selectedCounselor && selectedTimeSlot && !filteredStudents.length && load_count != 0"
            class="alert">No
            Record
            found .</p>
    </div>

    <!-- Modal -->
    <div v-if="showModal && selectedStudent" class="modal-overlay" :key="modalKey">
        <div class="modal">
            <h3>Mark Attendance</h3>
            <hr />
            <div class="modal-content">

                <div class="info-text"><strong>Student:</strong> {{ selectedStudent?.user?.name || '' }}</div>
                <!-- <div class="info-text"><strong>PIN Code (Testing):</strong> {{ selectedStudent?.pin_code || 'N/A' }} -->
                <!-- </div> -->


                <div class="info-text"><strong>Day:</strong> {{ getCurrentDayName() || '' }}</div>
                <div class="info-text"><strong>Date:</strong> {{ formatDateToUS(currentDate) || '' }}</div>
                <div class="info-text"><strong>Time:</strong> {{ convert24To12(currentTime) || '' }}</div>
                <label>Enter PIN Code:</label>
                <input type="password" v-model="pinCode" autocomplete="off" required />
                <p class="text-danger" v-html="pin_verification_message"></p>
            </div>

            <div class="modal-buttons">
                <button type="button" class="btn-primary" @click="verifyPin">Submit</button>
                <button type="button" class="btn-secondary" @click="closeModal">Cancel</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            students: [],
            filteredStudents: [],
            groups: [],
            counselors: [],
            timeSlots: [],
            selectedGroup: "0",
            selectedCounselor: "0",
            selectedTimeSlot: "0",
            searchQuery: "",
            days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
            selectedDate: '',
            // attendance: {},
            showModal: false,
            pin_verification_message: "",
            modalKey: 0,
            selectedStudent: null,
            selectedDay: "",
            currentDate: new Date().toISOString().split("T")[0],
            currentTime: "",
            pinCode: "",
            load_count: 0,
            startOfWeek: new Date(new Date().setDate(new Date().getDate() - new Date().getDay() + 1)),
            attendance: {},
        };
    },
    created() {
        this.fetchCounselors();
        this.fetchGroups();
        this.fetchTimeSlots();
        this.filterStudents();
        this.selectedDate = this.getLocalDate();
    },
    watch: {
        searchQuery() {
            this.filterStudents();
        }
    },
    methods: {
        getLocalDate() {
            const now = new Date();
            const offsetMs = now.getTimezoneOffset() * 60 * 1000;
            const localISOTime = new Date(now.getTime() - offsetMs).toISOString().split('T')[0];
            return localISOTime;
        },
        formatTime(time) {
            if (!time) return 'N/A';
            const [hours, minutes] = time.split(':');
            let h = parseInt(hours);
            const ampm = h >= 12 ? 'PM' : 'AM';
            h = h % 12 || 12; // Convert 0 to 12 for 12 AM
            return `${h}:${minutes} ${ampm}`;
        },

        getCurrentDayName() {

            const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
            const today = new Date();
            const dayName = days[today.getDay()];
            return dayName;
        },
        fetchCounselors() {
            let app = this;
            this.$api.get("/counselors").then((response) => {
                this.counselors = response.data;
                if (this.counselors.length == 1) {

                    console.log("only one counselor");
                    app.selectedCounselor = this.counselors[0].id;
                }
            }).catch(error => {
                console.error("Error fetching counselors", error);
            });
        },
        fetchTimeSlots() {
            this.$api.get("/time-slots").then((response) => {
                this.timeSlots = response.data;
            }).catch(error => {
                console.error("Error fetching time slots", error);
            });
        },

        getDateForDay(index) {
            const date = new Date();
            date.setDate(date.getDate() - date.getDay() + 1 + index);
            return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
        },

        formatDateToUS(dateString) {
            console.log(dateString);
            const [year, month, day] = dateString.split('-');
            return `${month}/${day}/${year}`;
        },
        fetchGroups() {
            this.$api.get("/groups").then((response) => {
                this.groups = response.data;
            });
        },
        fetchStudents() {
            if (!this.selectedGroup) {
                this.students = [];
                this.filteredStudents = [];
                return;
            }


            this.$api.get(`/groups/${this.selectedGroup}/students`).then((response) => {
                this.students = response.data;
                this.filterStudents();
                this.load_count = 1;
                this.fetchAttendanceRecords();
            });
        },
        async fetchAttendanceRecords() {
            this.attendance = [];
            let ids = this.filteredStudents.map(student => student.id);
            console.log(ids);
            await this.$api.post(`/attendance/filter`,
                {
                    'student_ids': ids,
                    'date': this.currentDate,
                    // 'counselor_id': this.selectedCounselor,
                    // 'time_slot_id': this.selectedTimeSlot
                }).then((response) => {
                    const attendanceData = response.data; // JSON object, not an array

                    // this.attendance

                    Object.keys(attendanceData).forEach(studentId => {
                        if (!this.attendance[studentId]) {
                            this.attendance[studentId] = {};
                        }

                        Object.keys(attendanceData[studentId]).forEach(day => {
                            this.attendance[studentId] = attendanceData[studentId][day]; // Assign status
                        });
                    });
                    // console.log(JSON.stringify(attendanceData));

                });
        },

        getCurrentTime24() {
            const date = new Date();
            return date.toTimeString().split(" ")[0];
        },

        convert24To12(timeString) {
            let [hours, minutes, seconds] = timeString.split(":");
            let period = hours >= 12 ? "PM" : "AM";
            hours = hours % 12 || 12;
            return `${hours}:${minutes}:${seconds} ${period}`;
        },
        async filterStudents() {

            // if (this.searchQuery == '') {
            //     this.students = [];
            //     this.filteredStudents = [];
            //     return;
            // }
            let app = this;
            try {
                const response = await this.$api.get('/students/iotp');
                app.filteredStudents = response.data;
                app.fetchAttendanceRecords();
            } catch (error) {
                console.error("Failed to load IOTP students:", error);
            }
            // this.filteredStudents = this.students.filter(student =>
            //     student.user.name.toLowerCase().includes(this.searchQuery.toLowerCase())
            // );
        },
        handleCheckboxChange(event, student, day) {
            // if (event.target.checked) {
            this.openModal(student, day);
            // } else {
            // this.closeModal();
            // }
        },
        openModal(student, day) {

            this.selectedStudent = student;
            this.selectedDay = day;
            // this.selectedDate = this.getDateForDay(this.days.findIndex(day => day === this.selectedDay));

            console.log(this.selectedStudent.id);
            this.currentTime = this.getCurrentTime24();
            this.pinCode = student.pin_code;
            this.showModal = true;
            this.modalKey++;
        },
        closeModal() {
            this.pin_verification_message = "";
            this.showModal = false;
        },
        verifyPin() {
            this.pin_verification_message = "";

            this.$api.post("/students/verify-pin", { student_id: this.selectedStudent.id, pin: this.pinCode }).then((response) => {
                if (response.data.valid) {

                    // if (!this.attendance[this.selectedStudent.id]) {
                    //     this.attendance[this.selectedStudent.id] = {};
                    // }
                    // this.attendance[this.selectedStudent.id][this.selectedDay] = "Present";


                    this.markAttendance();

                } else {
                    this.pin_verification_message = "Pin is not valid, Please try again";

                }

            });
        },
        async markAttendance() {
            const attendanceData = {
                student_id: this.selectedStudent.id,
                day_name: this.selectedDay,
                attendance_date: this.selectedDate,
                counselor_id: this.selectedCounselor,
                time_slot_id: this.selectedTimeSlot,
                group_id: this.selectedStudent.group_id,

                time: this.currentTime,
                status: "present",
                notes: "Auto-marked",
                date: this.selectedDate,
            };

            await this.$api.post("/attendance", attendanceData)
                .then(response => {
                    if (response.data.request_status == false) {
                        this.pin_verification_message = response.data.message;
                        return;
                    }
                    // console.log("Attendance saved", response.data);
                    this.fetchAttendanceRecords();
                    this.closeModal();
                })
                .catch(error => {

                    let errorMessages = '';
                    if (error.response?.data?.errors && typeof error.response.data.errors === 'object') {
                        errorMessages = Object.values(error.response.data.errors)
                            .flat()
                            .join("<br />");
                    } else if (error.response?.data?.message) {
                        // fallback message if Laravel sends a single message string
                        errorMessages = error.response.data.message;
                    } else {
                        errorMessages = 'An unexpected error occurred.';
                    }


                    this.pin_verification_message = errorMessages;
                    // } else {
                    //     console.error("Error saving attendance", error);
                    //     alert("An error occurred while saving attendance.");
                    // }

                });
        }
    }
};
</script>

<style>
.attendance-container {
    padding: 20px;
}

.table {
    width: 100%;
    border-collapse: collapse;
}

th,
td {
    padding: 10px;
    text-align: center;
    border: 1px solid #ddd;
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 1 !important;
    visibility: visible !important;
    z-index: 99999;
}

.modal {
    height: auto !important;
    background: white;
    padding: 20px;
    border-radius: 5px;
    width: 400px !important;
    max-height: 500px;
    text-align: left;
    display: flex !important;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    position: fixed !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
    overflow-y: auto;
}

.modal-content {
    width: 100%;
    border: none !important;
}

.modal-buttons {
    display: flex;
    justify-content: flex-start;
    gap: 10px;
    margin-top: 10px;
}

.btn-primary {
    background-color: #1Dbcbc;
    color: white;
    border: none;
    padding: 8px 12px;
    cursor: pointer;
    border-radius: 5px;
}

.btn-secondary {
    background-color: #222250;
    color: white;
    border: none;
    padding: 8px 12px;
    cursor: pointer;
    border-radius: 5px;
}

.modal input {
    margin-bottom: 10px;
    padding: 5px;
    width: 100%;
}

.info-text {
    margin: 5px 0;
    padding: 0;
    border: none !important;
    background: none !important;
    box-shadow: none !important;
}

.group-select-container,
.counselor-select-container,
.time-slot-select-container {
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    gap: 10px;
}

.group-select-container label,
.counselor-select-container label,
.time-slot-select-container label {
    font-weight: bold;
    width: 200px;
}

.group-dropdown,
.counselor-dropdown,
.time-slot-dropdown {
    padding: 8px;
    border-radius: 5px;
    border: 1px solid #ccc;
    font-size: 16px;
    width: 400px;
}

.group-dropdown:focus {
    border-color: #1Dbcbc;
    outline: none;
}

.search-container {
    margin-bottom: 15px;
    text-align: right;
}

.search-input {
    padding: 8px;
    border-radius: 5px;
    border: 1px solid #ccc;
    font-size: 16px;
    width: 100%;
}

.search-input:focus {
    border-color: #1Dbcbc;
    outline: none;
}

.table-container {
    /* max-height: 400px; */
    /* overflow-y: auto; */
}

.sticky-header {
    position: sticky;
    top: 0;
    background: white;
    z-index: 100;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}
</style>